import { useContext } from 'react';
import { Card, Field } from '../../../../layouts';
import { formatShortDate } from '../../../../utils/date-utils';
import { PurchaseOrderContext } from '../context/PurchaseOrderContext';

export default function PurchaseOrderDatesCard() {

	const { order } = useContext(PurchaseOrderContext);

	return (
		<Card header={'Dates'}>
			<Field label={'Requested Ship Date'} >
				{formatShortDate(order.details.requestedShipDate)}
			</Field>
			<Field label={'Validate Ship Date'} >
				{formatShortDate(order.details.validatedShipDate)}
			</Field>
			<Field label="Actual Ship Date" >
				{formatShortDate(order.details.actualShipDate)}
			</Field>
		</Card>
	);
}
